import axios from "axios";
import { jwtDecode } from "jwt-decode";

let tokenData = null;

export async function fetchToken() {
  const res = await axios.post("/api/token", {}, {
  });

  const token = res.data.token;
  const { exp } = jwtDecode(token); // decode JWT and extract expiration

  tokenData = {
    token,
    expiry: exp * 1000 // convert to ms
  };

  return tokenData.token;
}

export function getToken() {
  if (!tokenData) return null;
  if (Date.now() >= tokenData.expiry) {
    tokenData = null;
    return null;
  }
  return tokenData.token;
}
